import { render, staticRenderFns } from "./BotonCerrarTurno.vue?vue&type=template&id=5b55fbf4"
import script from "./BotonCerrarTurno.vue?vue&type=script&lang=js"
export * from "./BotonCerrarTurno.vue?vue&type=script&lang=js"
import style0 from "./BotonCerrarTurno.vue?vue&type=style&index=0&id=5b55fbf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports